export default __webpack_public_path__ + "static/yellow-64ff1c3d7ebbba069c0a09eeb5a4998a.gif";